module.exports = __webpack_public_path__ + "img/gkjixie.4449b92a.jpg";